<template>
    <form-row title="Price">
        <div class="flex flex-col sm:flex-row flex-1 -mt-2 sm:-mt-4 xl:pr-24">
            <div class="sm:mr-4 sm:w-1/2">
                <input-money
                    label="Agreed-Upon Purchase Price"
                    name="purchase_price"
                    v-model="purchase_price"
                    :read_only="read_only"
                />
            </div>

            <div class="sm:ml-4 mt-4 sm:mt-0 sm:w-1/2">
                <input-money
                    label="Net Sale Price"
                    name="net_sale_price"
                    v-model="net_sale_price"
                    :read_only="read_only"
                />
            </div>
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        deal: { default: () => ({}) },
        read_only: { default: false },
    },

    computed: {
        purchase_price: {
            get() {
                return store.state.purchase_price || null;
            },
            set(val) {
                store.state.purchase_price = val;
            },
        },
        net_sale_price: {
            get() {
                return store.state.net_sale_price || null;
            },
            set(val) {
                store.state.net_sale_price = val;
            },
        },
    },
}
</script>
